export enum SharedActionsEnum {
  ERROR = "ERROR",
  IS_LOADING = "IS_LOADING",
  ALERTS = "ALERTS",
  SUCCESS_MESSAGE = "SUCCESS_MESSAGE",
  USER_DATA = "USER_DATA",
  DIALOG_COUNTS = "DIALOG_COUNTS",
}
